/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import CMSDrugInputContainer from './CMSDrugInputContainer';
import CMSDrugTableComponent from './CMSDrugTableComponent';

const CMSDrug = (props) => {
  const { fullScreen, setFullScreen } = { ...props };
  const currentNDCDetailsSelected = useSelector(
    (state) => state.sharedState.ndc.currentNDCDetailsSelected
  );
  const referenceData = useSelector(
    (state) => state.sharedState.ndc.referenceData
  );

  const generalSystemParameterDetails = useSelector(
    (state) => state?.sharedState?.ndc?.generalSystemParameter?.paramGeneralVO
  );

  const [cmsDrugSelectedRow, setCmsDrugSelectedRow] = useState(null);
  useEffect(() => {
    const firstRow = currentNDCDetailsSelected?.cmsDrugVOs?.[0] || null;
    setCmsDrugSelectedRow(firstRow);
  }, [currentNDCDetailsSelected]);
  return (
    <div className="row">
      <div className={`${fullScreen ? 'col-12' : 'col-6'} `}>
        <CMSDrugTableComponent
          currentNDCDetailsSelected={currentNDCDetailsSelected}
          setCmsDrugSelectedRow={setCmsDrugSelectedRow}
          {...props}
        />
      </div>
      {!fullScreen && (
        <>
          <div className="col-6 ">
            <CMSDrugInputContainer
              cmsDrugSelectedRow={cmsDrugSelectedRow}
              referenceData={referenceData}
              generalSystemParameterDetails={generalSystemParameterDetails}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default CMSDrug;
